import React from 'react';

/* eslint-disable max-len */
const MagnifyIcon = () => (
  <svg className='bb-magnify-icon' viewBox="0 0 98.87 98.88"><title>refine-magnifying-glass</title><path d="M97.94,90.73,67.23,60A37.09,37.09,0,1,0,60,67.23L90.73,97.94a5.1,5.1,0,1,0,7.21-7.21Zm-41-33.8a27.26,27.26,0,1,1,0-38.58A27.12,27.12,0,0,1,56.93,56.93Z" transform="translate(-0.56 -0.56)"/></svg>
);

export default MagnifyIcon;
